import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, CheckIcon } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: <div className="flex text-brand-gold mr-1" data-id="element-265">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-266" />)}
        </div>,
    text: '4.9 · 595+ Google Reviews'
  }, {
    icon: <CheckIcon className="w-5 h-5 text-brand-dark mr-2" data-id="element-267" />,
    text: 'ASE-Certified Technicians'
  }, {
    icon: <CheckIcon className="w-5 h-5 text-brand-dark mr-2" data-id="element-268" />,
    text: '2-Year / 24,000-Mile Warranty'
  }, {
    icon: <CheckIcon className="w-5 h-5 text-brand-dark mr-2" data-id="element-269" />,
    text: 'Serving St. Paul Since 1977'
  }];
  return <div className="py-4 px-4 border-y border-brand-accentHover shadow-inner bg-[#c8b4a4]" data-id="element-270">
      <div className="max-w-6xl mx-auto" data-id="element-271">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-y-4 gap-x-8" data-id="element-272">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-center text-brand-dark font-bold text-sm md:text-base" data-id="element-273">
              {item.icon}
              <span data-id="element-274">{item.text}</span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}